import React from "react";

export interface RouterLinkProps {
  href: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

/**
 * Shared link component that:
 * - Passes through external/tel/mailto links
 * - Routes hash links to home ("/#section")
 * - Uses whatever routing adapter is provided by the app (react-router, etc.)
 *
 * Note: Apps should wrap this component with their router's Link for SPA navigation.
 */
export function createRouterLinkAdapter(
  LinkComponent: React.ComponentType<any>
) {
  return function RouterLink({ href, className, children, onClick }: RouterLinkProps) {
    const isExternal = /^https?:\/\//i.test(href) || href.startsWith("mailto:") || href.startsWith("tel:");
    if (isExternal) {
      return (
        <a href={href} className={className} onClick={onClick}>
          {children}
        </a>
      );
    }

    // Hash links should land on home with hash (e.g., "/#services")
    if (href.startsWith("#")) {
      return (
        <LinkComponent to={{ pathname: "/", hash: href }} className={className} onClick={onClick}>
          {children}
        </LinkComponent>
      );
    }

    return (
      <LinkComponent to={href} className={className} onClick={onClick}>
        {children}
      </LinkComponent>
    );
  };
}
